/**
 * @author: junjunzuo(junjunzuo@tencent.com)
 * @description: detail
 * @Date: 2020-06-15 16:43:40
 */

import * as types from '@types';
import axios from 'axios';

export default {
  namespaced: true,
  state: () => ({
    videoInfo: {},
  }),
  mutations: {
    [types.UPDATE_VIDEO_INFO](state, info) {
      state.videoInfo = info;
    },
  },
  actions: {
    async prefetchData({ commit }, { context, route }) {
      const $params = context ? context.$params : {};
      const params = Object.assign({}, route.query, $params);
      let result = await axios({
        url: `${types.ORIGIN_CLIENT}/napi/sa/info`,
        params,
      }).catch(err => console.log(err));
      result = result && result.data;
      const { status, data: itemData } = result || {};
      if (status === 0 && itemData) {
        commit(types.UPDATE_VIDEO_INFO, itemData);
        return itemData;
      }
      commit(types.UPDATE_VIDEO_INFO, {});

      return {
        status: 302,
        redirectUrl: '/?prefetch_redirect=1',
      };
    },
  },
};
